import styled from 'styled-components/macro';
import {Modal} from "@material-ui/core";
import { device } from '../../styles/devices';

export const ModalStyle = styled(Modal)`
  @media ${device.mobileLrg} {
    width: 100%;
  }
  @media ${device.laptop} {
    padding-left: 30%;
    padding-right: 30%;
    padding-top:10%;
  }
  background-color: transparent;
  justify-content: center;
`
